export default {

  reports: {
    // ---- AI report error codes (backend `errorCode`) -> localized messages ----
    errors: {
      INSUFFICIENT_CREDITS:
        "You don't have enough AI credits to generate this report. Please contact your administrator.",
      REPORT_ACCESS_DENIED: "This AI report is not enabled for your account.",
      NOT_FOUND: "The requested report could not be found.",
      INVALID_INPUT: "Some of the details provided are invalid. Please review and try again.",
      INVALID_GEOMETRY: "The selected area is not valid. Please adjust the geofence and try again.",
    },
    // ---- Estimated Compute Cost card (shared across AI report create screens) ----
    computeCost: {
      title: "Estimated Compute Cost",
      totalRequired: "Total Credits Required",
      available: "Credits Available",
      status: "Status",
      sufficient: "Credits Sufficient for AI Report Generation",
      insufficient: "Insufficient Credits for AI Report Generation",
      calculating: "Calculating…",
      credits: "Credits",
    },
    // ---- Crop Progression / Vegetation Vigor Analysis ----
    cropProgression: {
      title: "Vegetation Vigor Analysis",
      listOfReports: "List of Reports",
      createNewReport: "Create New Report",
      backToDashboard: "Back to Dashboard",
      generateReport: "Generate Report",
      cancel: "Cancel",
      back: "Back",
      deleteReport: "Delete Report",
      downloadReport: "Download Report",
      compareImages: "Compare Images",
      aiReportGuide: "AI Report Guide",
      search: "Search",
      // table columns
      reportId: "Report ID",
      farmAndFarmId: "Farm & Farm ID",
      producerName: "Producer Name",
      dateOfReport: "Date of Report",
      selectedDate: "Report Date",
      status: "Status",
      statusCompleted: "Completed",
      statusGenerating: "Generating",
      statusPartial: "Partial",
      statusFailed: "Failed",
      location: "Location",
      farm: "Farm",
      zone: "Zone",
      actions: "Actions",
      view: "View",
      delete: "Delete",
      // geofence selection
      selectFarmGeofence: "Select Farm Geofence",
      selectFarmGeofenceHelp: "Select a registered farm, draw your farm boundary on the map, or upload a GeoJSON to begin analyzing your farm area.",
      point: "Point",
      geofence: "Geofence",
      selectFarmZone: "Select Farm / Zone",
      sourceFarmZone: "Farm / Zone",
      sourcePolygon: "Polygon",
      sourceCircle: "Circle",
      sourceGeojson: "GeoJSON",
      mapView: "Map View",
      latitude: "Latitude",
      longitude: "Longitude",
      radiusKm: "Radius (km)",
      radiusM: "Radius (m)",
      enterHere: "Enter here",
      select: "Select",
      uploadGeojsonFile: "Upload GeoJSON File",
      uploadGeojsonHelp: "Select a GeoJSON file with your geofence from your computer and upload it. Only one geofence will be uploaded at a time, even if your file has multiple geofences.",
      selectAFile: "Select a File",
      drawPolygon: "Draw Polygon",
      drawPolygonHelp: "Click on the map to add points.",
      drawCircle: "Draw Circle",
      drawCircleHelp: "Click on the map to set the center; set the radius below or drag the circle to resize.",
      clearDrawing: "Clear",
      searchLocation: "Search location",
      closePolygonHint: "Click the first point to close the area",
      unnamedFarm: "Farm #{id}",
      unnamedZone: "Zone #{id}",
      // available date selection
      selectDate: "Select Date",
      availableDates: "Available Dates",
      fetchingDates: "Fetching available dates...",
      noAvailableDates: "No satellite dates are available for this area.",
      selectDateToGenerate: "Select an available date, then generate the report.",
      // compute cost (credits placeholder)
      estimatedComputeCost: "Estimated Compute Cost",
      totalCreditsRequired: "Total Credits Required",
      creditsAvailable: "Credits Available",
      creditsSufficient: "Credits Sufficient for AI Report Generation",
      // report view
      reportType: "Report Type",
      selectReportType: "Select Report Type",
      chooseIndexHelp: "Choose a satellite index to analyze your crop growth, moisture, or nutrient levels over time.",
      scale: "Scale",
      generating: "Generating report...",
      generatingHelp: "Your report is being generated. This can take a few minutes.",
      partialWarning: "Some indices could not be generated for this date.",
      failed: "Report generation failed.",
      valuesCloseToOne: "The values close to 1 indicate healthier vegetation",
      disclaimerTitle: "DISCLAIMER",
      disclaimer: "This AI-generated report is intended to serve as a guide. For accurate diagnosis and tailored recommendations, we strongly advise consulting with a qualified agronomist or agricultural expert.",
      // index labels
      indexNDVI: "Crop Health (NDVI)",
      indexMSAVI: "Early Stage Vegetation Growth (MSAVI)",
      indexLSWI: "Moisture Content (LSWI)",
      indexRECI: "Nutrient Level Estimation (RECI)",
      indexNDRE: "Greenness & Canopy Density (NDRE)",
      // comparison
      reportComparison: "Vegetation Vigor Analysis Report Comparison",
      imageComparison: "Image Comparison",
      sideComparison: "Side Comparison",
      sliderComparison: "Slider Comparison",
      transparencyComparison: "Transparency Comparison",
      transparencySlider: "Transparency Slider",
      notGeneratedPrompt: "This report has not been generated yet for the selected date. Generate it now?",
      generateNow: "Generate Now",
      // feedback
      feedback: "Feedback",
      doYouAgree: "Do you agree with the prediction?",
      agree: "Agree",
      disagree: "Disagree",
      agreedWithPrediction: "Agreed with Prediction",
      disagreedWithPrediction: "Disagreed with Prediction",
      disagreeHelp: "If you don't agree with this result, please provide your feedback",
      addFeedback: "Add feedback",
      feedbackPlaceholder: "Enter here",
      attachmentsOptional: "Attachments (Optional)",
      attachments: "Attachments",
      download: "Download",
      attachmentsHelp: "Drag & drop images or videos here, or browse files. Supported formats: JPG, PNG, MP4.",
      selectFilesToUpload: "Select files to Upload the Data",
      orDragAndDrop: "or drag and drop here",
      submit: "Submit",
      feedbackSubmitted: "Feedback submitted successfully.",
      feedbackAlreadySubmitted: "Feedback has already been submitted for this report.",
      // guide
      guideTitle: "Vegetation Vigor Analysis Guide",
      guideStep: "Step {current} of {total}",
      next: "Next",
      close: "Close",
      guideStep1Title: "What is Vegetation Vigor Analysis Report?",
      guideStep1Body: "This analysis helps you identify areas of your farm with low vegetation vigor so you can take timely action. The report uses satellite imagery to show how healthy your crops are at a specific point in time.\n\nThe heatmap shows which parts of your farm may need attention. By comparing images from different dates, you can track whether your crops are improving or declining over time and adjust your practices accordingly.",
      guideStep2Title: "How to Generate a Report?",
      guideStep2Body: "Creating your report is easy:\n\n1. Select your farm from the dropdown menu (if already registered). The boundary will appear on the map. Or, draw your farm boundary manually on the map if it's not registered yet.\n2. Pick a date: This is the date you want to see vegetation vigor data for.\n3. Click \"Generate Report\" to view your vegetation vigor analysis.",
      guideStep3Title: "How to Interpret the Report?",
      guideStep3Body: "Once the report is generated, you'll see a heatmap of your farm with green, yellow, and red colors.\n\nGreen = High vegetation vigor\nYellow/Red = Lower vigor → may require attention\n\nLow vigor may be caused by harvest, poor soil, pests, or even recent weather events.",
      guideTip: "Tip:",
      guideTipBody: "Use the date toggle located under the heatmap to view multiple reports and track changes in crop health over time. You can save, download, or delete your reports anytime for future use.",
      additionalReportTypes: "Additional Report Types Available:",
      // errors / notifications
      invalidGeojsonFile: "Invalid GeoJSON file",
      invalidGeojsonFileDescription: "The selected file is not a valid GeoJSON. Please check and try again.",
      geofenceRequired: "Please select a farm/zone, draw a geofence, or upload a GeoJSON.",
      dateRequired: "Please select an available date.",
      generateFailed: "Could not start report generation. Please try again.",
      loadFailed: "Could not load the report. Please try again.",
      datesFailed: "Could not fetch available dates. Please try again.",
      deleteConfirmTitle: "Delete Report",
      deleteConfirmMessage: "Are you sure you want to delete this report? This action cannot be undone.",
      deleted: "Report deleted successfully.",
      uploadFailed: "File upload failed. Please try again.",
    },
    // ---- Farm Productivity / Productivity Zones Analysis ----
    farmProductivity: {
      title: "Farm Productivity Analysis",
      listOfReports: "List of Reports",
      createNewReport: "Create New Report",
      backToDashboard: "Back to Dashboard",
      generateReport: "Generate Report",
      cancel: "Cancel",
      back: "Back",
      deleteReport: "Delete Report",
      downloadReport: "Download Report",
      aiReportGuide: "AI Report Guide",
      viewGuide: "View Guide",
      howToUseReport: "How to Use Report?",
      search: "Search",
      // table columns
      reportId: "Report ID",
      farmAndFarmId: "Farm & Farm ID",
      producerName: "Producer Name",
      dateOfReport: "Date of Report",
      status: "Status",
      statusCompleted: "Completed",
      statusGenerating: "Generating",
      statusFailed: "Failed",
      location: "Location",
      farm: "Farm",
      zone: "Zone",
      actions: "Actions",
      view: "View",
      delete: "Delete",
      // geofence selection
      selectFarmGeofence: "Select Farm Geofence",
      selectFarmGeofenceHelp: "Select a registered farm, draw your farm boundary on the map, or upload a GeoJSON to begin analyzing the productivity of your farm area.",
      selectFarmZone: "Select Farm / Zone",
      sourceFarmZone: "Farm / Zone",
      sourcePolygon: "Polygon",
      sourceCircle: "Circle",
      sourceGeojson: "GeoJSON",
      radiusM: "Radius (m)",
      select: "Select",
      uploadGeojsonFile: "Upload GeoJSON File",
      uploadGeojsonHelp: "Select a GeoJSON file with your geofence from your computer and upload it. Only one geofence will be uploaded at a time, even if your file has multiple geofences.",
      selectAFile: "Select a File",
      drawPolygon: "Draw Polygon",
      drawPolygonHelp: "Click on the map to add points.",
      drawCircle: "Draw Circle",
      drawCircleHelp: "Click on the map to set the center; set the radius below or drag the circle to resize.",
      // compute cost (credits placeholder)
      estimatedComputeCost: "Estimated Compute Cost",
      totalCreditsRequired: "Total Credits Required",
      creditsComingSoon: "Credit system coming soon.",
      // report view
      reportDetails: "Report Details",
      generating: "Generating report...",
      generatingHelp: "Your report is being generated. This can take a few minutes.",
      failed: "Report generation failed.",
      reportDescription: "Productivity zones report analyzes the productivity of your farm area based on historical vegetation vigor. This report is based on the analysis of vegetation vigor in your area. The productivity mapping allows you to determine the regions within your farm that have been consistently showing good or bad productivity over a period of many years. This tool will allow you to correct the lowest (red) and moderate (yellow) productivity zones so as to give you the potential to produce yields comparable to those of the highest (green) productivity zones. For example, if the lower productivity zones are a result of low soil moisture, then you can correct this deficiency by increasing the irrigation on those lower productivity zones. Another example is if the lower productivity zones are due to lack of certain nutrients, then you can correct this deficiency by adding more nutrients to those precise regions.",
      disclaimerTitle: "DISCLAIMER",
      disclaimer: "This AI-generated report is intended to serve as a guide. For accurate diagnosis and tailored recommendations, we strongly advise consulting with a qualified agronomist or agricultural expert.",
      // zone cards (indexed by sort order: 0 = Lowest ... 2 = Highest)
      zoneLabels: {
        "Lowest Productivity Zones": "Lowest Productivity Zones",
        "Low Productivity Zones": "Low Productivity Zones",
        "Moderate Productivity Zones": "Moderate Productivity Zones",
        "High Productivity Zones": "High Productivity Zones",
        "Highest Productivity Zones": "Highest Productivity Zones",
      },
      zoneDesc: {
        "Lowest Productivity Zones": "Areas with the poorest crop performance that require immediate attention or intervention.",
        "Low Productivity Zones": "Areas with below-average crop performance that need improvement.",
        "Moderate Productivity Zones": "Areas with moderate crop performance that may need some adjustments.",
        "High Productivity Zones": "Areas with above-average crop performance and good yield potential.",
        "Highest Productivity Zones": "Areas with optimal crop performance and the highest yield potential.",
      },
      // feedback
      feedback: "Feedback",
      doYouAgree: "Do you agree with the prediction?",
      agree: "Agree",
      disagree: "Disagree",
      agreedWithPrediction: "Agreed with Prediction",
      disagreedWithPrediction: "Disagreed with Prediction",
      disagreeHelp: "If you don't agree with this result, please provide your feedback",
      addFeedback: "Add feedback",
      feedbackPlaceholder: "Enter here",
      attachmentsOptional: "Attachments (Optional)",
      attachments: "Attachments",
      download: "Download",
      attachmentsHelp: "Drag & drop images or videos here, or browse files. Supported formats: JPG, PNG, MP4.",
      selectFilesToUpload: "Select files to Upload the Data",
      orDragAndDrop: "or drag and drop here",
      submit: "Submit",
      feedbackSubmitted: "Feedback submitted successfully.",
      feedbackAlreadySubmitted: "Feedback has already been submitted for this report.",
      // guide
      guideTitle: "Productivity Zones Guide",
      guideStep: "Step {current} of {total}",
      next: "Next",
      close: "Close",
      guideStep1Title: "What is Productivity Zones Report?",
      guideStep1Body: "Productivity Zones Report analyzes the productivity of the areas within your zone, that is, their potential to produce yields.",
      guideStep2Title: "How to Generate a Report?",
      guideStep2Body: "Creating your report is easy:\n\n1. Select your farm from the dropdown menu (if already registered). The boundary will appear on the map. Or, draw your farm boundary (polygon) manually on the map if it's not registered yet. You can also search by typing a location to zoom into an area.\n2. Save your geofence: Assign a name to your farm and input the Farm Registration ID (if applicable). Check the box to save the geofence for future use.\n3. Click \"Generate Report\" to view the productivity zones report for your farm.",
      guideStep3Title: "How to Interpret the Report?",
      guideStep3Body: "Once generated, the report shows a color-coded map dividing your farm into three productivity zones based on vegetation vigor and crop health:\n\nHighest Productivity Zones (Green): Areas that have historically demonstrated better soil and humidity characteristics, and are therefore more likely to produce higher yields.\nModerate Productivity Zones (Yellow): Areas that, based on historical averages, have shown moderate productivity relative to the high and low productivity zones.\nLowest Productivity Zones (Orange): Areas with potential for improvement, as they have historically been less productive than the high productivity zones.",
      guideTip: "Tip:",
      guideTipBody: "Start with orange zones — they need the most urgent improvements. Study green zones to understand what's working well and apply those practices in weaker areas.\nUse the report over time to track improvements or worsening in different zones across seasons.\n\nYou can save, download, or delete your reports for future reference.",
      // errors / notifications
      invalidGeojsonFile: "Invalid GeoJSON file",
      invalidGeojsonFileDescription: "The selected file is not a valid GeoJSON. Please check and try again.",
      generateFailed: "Could not start report generation. Please try again.",
      loadFailed: "Could not load the report. Please try again.",
      deleteConfirmTitle: "Delete Report",
      deleteConfirmMessage: "Are you sure you want to delete this report? This action cannot be undone.",
      deleted: "Report deleted successfully.",
      uploadFailed: "File upload failed. Please try again.",
    },
    // ---- Anomaly Detection ----
    anomalyDetection: {
      title: "Anomalies Detection",
      reportComparison: "Report Comparison",
      listOfReports: "List of Reports",
      createNewReport: "Create New Report",
      backToDashboard: "Back to Dashboard",
      generateReport: "Generate Report",
      cancel: "Cancel",
      back: "Back",
      deleteReport: "Delete Report",
      downloadReport: "Download Report",
      compareReports: "Compare Reports",
      aiReportGuide: "AI Report Guide",
      search: "Search",
      // table columns
      reportId: "Report ID",
      farmAndFarmId: "Farm & Farm ID",
      producerName: "Producer Name",
      dateOfReport: "Date of Report",
      status: "Status",
      statusCompleted: "Completed",
      statusGenerating: "Generating",
      statusPartial: "Partial",
      statusFailed: "Failed",
      location: "Location",
      farm: "Farm",
      zone: "Zone",
      actions: "Actions",
      view: "View",
      delete: "Delete",
      // geofence selection
      selectFarmGeofence: "Select Farm Geofence",
      selectFarmGeofenceHelp: "Select a registered farm, draw your farm boundary on the map, or upload a GeoJSON to begin detecting anomalies in your farm area.",
      selectFarmZone: "Select Farm / Zone",
      sourceFarmZone: "Farm / Zone",
      sourcePolygon: "Polygon",
      sourceCircle: "Circle",
      sourceGeojson: "GeoJSON",
      radiusM: "Radius (m)",
      select: "Select",
      uploadGeojsonFile: "Upload GeoJSON File",
      uploadGeojsonHelp: "Select a GeoJSON file with your geofence from your computer and upload it. Only one geofence will be uploaded at a time, even if your file has multiple geofences.",
      selectAFile: "Select a File",
      drawPolygon: "Draw Polygon",
      drawPolygonHelp: "Click on the map to add points.",
      drawCircle: "Draw Circle",
      drawCircleHelp: "Click on the map to set the center; set the radius below or drag the circle to resize.",
      // detect anomalies section
      detectAnomalies: "Detect Anomalies",
      detectAnomaliesHelp: "After drawing or uploading a geofence, select the date of interest to be able to detect and view the results.",
      startDate: "Start Date",
      fetchingDates: "Fetching available dates...",
      noAvailableDates: "No satellite dates are available for this area.",
      selectDateToGenerate: "Select an available date, then generate the report.",
      numberOfHistoricalReports: "Number of Historical Reports",
      historicalReportsPlaceholder: "Enter here",
      historicalReportsNote: "Increasing this count will consume additional AI credits for each historical image requested.",
      // compute cost (credits placeholder)
      estimatedComputeCost: "Estimated Compute Cost",
      totalCreditsRequired: "Total Credits Required",
      creditsComingSoon: "Credit system coming soon.",
      // report view
      selectDate: "Select Date",
      reportDetails: "Report Details",
      closestImageNote: "Satellite imagery for {requested} was not available. We've used the closest available image from {resolved} instead.",
      generating: "Generating report...",
      generatingHelp: "Your report is being generated. This can take a few minutes.",
      partialWarning: "Some dates could not be generated for this report.",
      failed: "Report generation failed.",
      disclaimerTitle: "DISCLAIMER",
      disclaimer: "This AI-generated report is intended to serve as a guide. For accurate diagnosis and tailored recommendations, we strongly advise consulting with a qualified agronomist or agricultural expert.",
      // performance bands
      greenAreas: "Green Areas",
      greenAreasDesc: "Current Vegetation Vigor outperforms historical average",
      yellowAreas: "Yellow Areas",
      yellowAreasDesc: "Current vegetation vigor performs according to historical average",
      redAreas: "Red Areas",
      redAreasDesc: "Areas with poor crop performance that require immediate attention or intervention.",
      underperforming: "Underperforming",
      outperforming: "Outperforming",
      // comparison
      imageComparison: "Report Comparison",
      sideComparison: "Side Comparison",
      sliderComparison: "Slider Comparison",
      transparencyComparison: "Transparency Comparison",
      transparencySlider: "Transparency Slider",
      notGeneratedPrompt: "This report has not been generated yet for the selected date. Generate it now?",
      generateNow: "Generate Now",
      // feedback
      feedback: "Feedback",
      doYouAgree: "Do you agree with the prediction?",
      agree: "Agree",
      disagree: "Disagree",
      agreedWithPrediction: "Agreed with Prediction",
      disagreedWithPrediction: "Disagreed with Prediction",
      disagreeHelp: "If you don't agree with this result, please provide your feedback",
      addFeedback: "Add feedback",
      feedbackPlaceholder: "Enter here",
      attachmentsOptional: "Attachments (Optional)",
      attachments: "Attachments",
      download: "Download",
      attachmentsHelp: "Drag & drop images or videos here, or browse files. Supported formats: JPG, PNG, MP4.",
      selectFilesToUpload: "Select files to Upload the Data",
      orDragAndDrop: "or drag and drop here",
      submit: "Submit",
      feedbackSubmitted: "Feedback submitted successfully.",
      feedbackAlreadySubmitted: "Feedback has already been submitted for this report.",
      // guide
      guideTitle: "Anomalies Detection Guide",
      guideStep: "Step {current} of {total}",
      next: "Next",
      close: "Close",
      guideStep1Title: "What is Anomalies Detection?",
      guideStep1Body: "Anomalies Detection compares your field's current vegetation performance against its historical average for the same area. Each heat map highlights where your crops are performing better or worse than usual.\n\nGreen areas outperform the historical average, red areas underperform, and yellow areas are in line with it.",
      guideStep2Title: "How to Generate a Report?",
      guideStep2Body: "Creating your report is easy:\n\n1. Select your farm from the dropdown menu (if already registered). The boundary will appear on the map. Or draw your farm boundary manually on the map if it's not registered yet. You can also search by typing Latitude and Longitude to zoom into a location.\n2. Pick a start date and the number of historical reports you want to analyze.\n3. Click \"Generate Report\" to view the anomalies detection report for your farm.",
      guideStep3Title: "How to Interpret the Report?",
      guideStep3Body: "Once generated, the report shows a color-coded heat map of your farm based on how current vegetation vigor compares to the historical average:\n\nGreen: areas outperforming the historical average.\nYellow: areas performing in line with the historical average.\nRed: areas underperforming and likely needing attention.",
      guideTip: "Tip:",
      guideTipBody: "Date Comparison: The report provides heat maps for multiple dates, allowing you to track changes in vegetation vigor over time and identify recurring issues.\n\nFocus on zones that consistently appear red across multiple heat maps. These areas likely need long-term solutions, such as soil management or irrigation system upgrades.\n\nYou can save, download, or delete your reports for future reference.",
      // errors / notifications
      invalidGeojsonFile: "Invalid GeoJSON file",
      invalidGeojsonFileDescription: "The selected file is not a valid GeoJSON. Please check and try again.",
      geofenceRequired: "Please select a farm/zone, draw a geofence, or upload a GeoJSON.",
      dateRequired: "Please select an available date.",
      generateFailed: "Could not start report generation. Please try again.",
      loadFailed: "Could not load the report. Please try again.",
      datesFailed: "Could not fetch available dates. Please try again.",
      deleteConfirmTitle: "Delete Report",
      deleteConfirmMessage: "Are you sure you want to delete this report? This action cannot be undone.",
      deleted: "Report deleted successfully.",
    },
    yieldPredictionDesign: {
      disclaimerTitle: "DISCLAIMER",
      disclaimerIntro: "In our yield predictions, the uncertainty may be 100% because there are many factors that are beyond our control, including:",
      disclaimer1: "It is impossible to accurately predict the weather for a whole season, so in some cases farmers could lose all their harvest due to just one hail event or flooding (especially now that global warming is often causing all these irregularities).",
      disclaimer2: "Yields are highly dependent on the management practices of farmers. For example, if they fail to spray pesticides at the right time, or irrigate properly, then yields will be very different from the predictions - this is also beyond our control.",
      disclaimer3: "There are many other factors like the above that may contribute to significant errors in the AI yield predictions.",
      disclaimer4: "If the farmer provides historical yields (ADVANCED mode), then predictions tend to be more accurate than the default (non-ADVANCED mode) predictions.",
      // feedback (shared FeedbackDisplay / FeedbackDialog)
      feedback: "Feedback",
      doYouAgree: "Do you agree with the prediction?",
      agree: "Agree",
      disagree: "Disagree",
      agreedWithPrediction: "Agreed with Prediction",
      disagreedWithPrediction: "Disagreed with Prediction",
      disagreeHelp: "If you don't agree with this result, please provide your feedback",
      addFeedback: "Add feedback",
      feedbackPlaceholder: "Enter here",
      attachmentsOptional: "Attachments (Optional)",
      attachments: "Attachments",
      download: "Download",
      attachmentsHelp: "Drag & drop images or videos here, or browse files. Supported formats: JPG, PNG, MP4.",
      selectFilesToUpload: "Select files to Upload the Data",
      orDragAndDrop: "or drag and drop here",
      submit: "Submit",
      feedbackSubmitted: "Feedback submitted successfully.",
      feedbackAlreadySubmitted: "Feedback has already been submitted for this report.",
      uploadFailed: "File upload failed. Please try again.",
    },
    landSuitabilityDesign: {
      reportDetails: "Report Details",
      greenAreas: "Green Areas",
      greenAreasDesc: "Areas rated highly suitable for the selected crop",
      yellowAreas: "Yellow Areas",
      yellowAreasDesc: "Areas with moderate suitability that may need attention",
      redAreas: "Red Areas",
      redAreasDesc: "Areas rated unsuitable and likely needing intervention",
      underperforming: "Underperforming",
      outperforming: "Outperforming",
      // feedback (shared FeedbackDisplay / FeedbackDialog)
      feedback: "Feedback",
      doYouAgree: "Do you agree with the prediction?",
      agree: "Agree",
      disagree: "Disagree",
      agreedWithPrediction: "Agreed with Prediction",
      disagreedWithPrediction: "Disagreed with Prediction",
      disagreeHelp: "If you don't agree with this result, please provide your feedback",
      addFeedback: "Add feedback",
      feedbackPlaceholder: "Enter here",
      attachmentsOptional: "Attachments (Optional)",
      attachments: "Attachments",
      download: "Download",
      attachmentsHelp: "Drag & drop images or videos here, or browse files. Supported formats: JPG, PNG, MP4.",
      selectFilesToUpload: "Select files to Upload the Data",
      orDragAndDrop: "or drag and drop here",
      submit: "Submit",
      feedbackSubmitted: "Feedback submitted successfully.",
      feedbackAlreadySubmitted: "Feedback has already been submitted for this report.",
      uploadFailed: "File upload failed. Please try again.",
    },
    // ---- AI Credit Management (Super Admin + Client Admin) ----
    aiCredit: {
      title: "AI Reports Management",
      cancel: "Cancel",
      save: "Save",
      submit: "Submit",
      close: "Close",
      back: "Back",
      search: "Search",
      makeSelection: "Make a selection",
      all: "All",
      loadFailed: "Could not load data. Please try again.",
      saveFailed: "Could not save. Please try again.",
      saved: "Saved successfully.",
      // tabs
      tabCooperativeCredits: "Cooperative Credits Management",
      tabCreditRates: "AI Report Credit Rates",
      tabUsageLog: "Credits Usage Log",
      tabFeedback: "AI Reports Feedback",
      // report type labels
      rt_vegetation_vigor: "Vegetation Vigor Analysis",
      rt_farm_productivity: "Farm Productivity Analysis",
      rt_anomaly_detection: "Anomalies Detection",
      rt_yield_prediction: "Yield Prediction",
      rt_disease_detection: "Disease Detection",
      rt_land_suitability: "Land Suitability",
      // cooperative credit management
      coopMgmtTitle: "Cooperative Credit Management & Allocation",
      coopMgmtHelp: "Configure and manage the credit consumption rates for each AI report type. Adjust these values to reflect operational costs and maintain balance across your reporting services.",
      listOfCooperatives: "List of Cooperatives",
      colCooperative: "Cooperative",
      colContactEmail: "Contact Email",
      colAllocationPlan: "Allocation Plan",
      colCreditsAvailable: "Credits Available",
      colReserved: "Reserved Credits",
      colLastTopup: "Last Topup",
      colStatus: "Status",
      colPrimaryUser: "Primary User",
      credits: "Credits",
      planOneTime: "One Time",
      planMonthly: "Monthly",
      planYearly: "Yearly",
      // row actions
      addInstantCredits: "Add Instant Credits",
      manageCredits: "Manage Credits",
      creditsHistory: "Credits History",
      // credit rates
      ratesTitle: "AI Report Credit Rates",
      ratesHelp: "Define the cost in credits for each AI report type. These rates will be deducted from a cooperative's balance whenever a report is generated. Please note: By updating these rates, all future reports generated by users will be charged at the new defined rates effective immediately.",
      perAcre: "Per Acre",
      perReport: "Per Report",
      rolloverTitle: "Credits Rollover Settings",
      rolloverHelp: "Define how unused cooperative credits are handled at the end of the billing cycle.",
      rolloverUnused: "Rollover Unused Credits",
      yes: "Yes",
      no: "No",
      // usage log
      usageLogTitle: "Credits Usage Log",
      usageLogHelp: "A comprehensive audit trail of all credit consumption across the network. Track individual transactions, identify usage patterns, and ensure transparent budget distribution across all cooperative levels.",
      colDateTime: "Date & Time",
      colAction: "Action",
      colDescription: "Description",
      colChange: "Change",
      colBalance: "Balance",
      colUser: "User",
      colReportType: "Report Type",
      colReportId: "Report Id",
      actionAllocation: "Allocation",
      actionRecurringAllocation: "Recurring Allocation",
      actionTopUp: "Top-up",
      actionReservation: "Reservation",
      actionReservationRelease: "Reservation Release",
      actionReportUsage: "Report Usage",
      actionAdjustment: "Adjustment",
      // feedback dashboard
      feedbackTitle: "AI Reports Feedback",
      feedbackHelp: "Monitor how users rate the AI reports across the network.",
      overallSatisfaction: "Overall Satisfaction Rate",
      agreeCount: "Agreed",
      disagreeCount: "Disagreed",
      topDisagreed: "Top Disagreed Report Types",
      colDate: "Date",
      colUserRole: "User Role",
      colOrganization: "Organization",
      colFeedback: "Feedback",
      colComment: "Comment",
      colAttachment: "Attachment",
      agreed: "Agreed",
      disagreed: "Disagreed",
      viewAttachment: "View Attachment",
      noComment: "—",
      // add instant credits dialog
      addInstantTitle: "Add Instant Credits",
      addInstantDesc: "Manually add credits to this cooperative's balance. This is a one-time transaction and will not affect the cooperative's existing allocation plan.",
      country: "Country",
      addCredits: "Add Credits",
      creditsAdded: "Credits added successfully.",
      // manage credits dialog
      manageTitle: "Manage Cooperative Credits",
      manageDesc: "Adjust credit balances or set up recurring allocations for this cooperative. Changes to balances take effect immediately.",
      oneTimeTopup: "One Time Top-up",
      recurringAllocation: "Recurring Allocation",
      frequency: "Frequency",
      // credits history dialog
      historyTitle: "Credits History",
      historyDesc: "A overview of credit allocations versus consumption for this cooperative. Use this summary to track monthly usage trends and billing cycles.",
      refreshesOn: "Refreshes On",
      colMonth: "Month",
      colCreditsAssigned: "Credits Assigned",
      colCreditsUsed: "Credits Used",
      colClosingBalance: "Closing Balance",
      // notify titles
      errorTitle: "Error",
      successTitle: "Success",
      // credits history dialog (extra)
      creditsAvailable: "Credits Available",
      noHistory: "No credit history yet.",
      // credit rates (extra)
      saveChanges: "Save Changes",
      colCreditCost: "Credit Cost",
      colCalcType: "Calculation Type",
      colRollover: "Rollover",
      colActive: "Active",
      // usage log (extra)
      searchDescription: "Search description",
      filterCooperative: "Cooperative",
      filterAction: "Action",
      colNewBalance: "New Balance",
      action_allocation: "Allocation",
      action_recurring_allocation: "Recurring Allocation",
      action_top_up: "Top-up",
      action_reservation: "Reservation",
      action_reservation_release: "Reservation Release",
      action_report_usage: "Report Usage",
      action_adjustment: "Adjustment",
      // feedback dashboard (extra)
      mTotalFeedback: "Total Feedback",
      mSatisfaction: "Satisfaction Rate",
      mAgree: "Agreed",
      mDisagree: "Disagreed",
      topDisagreedTitle: "Top Disagreed Reports",
      noData: "No data available.",
      feedbackListTitle: "Recent Feedback",
      filterReportType: "Report Type",
      colResponse: "Response",
      colAttachments: "Attachments",
      agree: "Agree",
      disagree: "Disagree",
      // feedback attachment dialog
      attachmentsTitle: "Feedback Attachments",
      noAttachments: "No attachments.",
      download: "Download",
      // feedback dashboard (redesign)
      perfTitle: "AI Reports Performance & Feedback",
      perfHelp:
        "Monitor user sentiment and report accuracy across all AI models. Use these insights to identify model drifts and prioritize areas for further calibration.",
      filterDateRange: "Date Range",
      filterFeedbackValue: "Feedback Value",
      selectDate: "Select Date",
      satisfactionTitle: "Overall Satisfaction Rate",
      agreementScore: "Overall Agreement Score",
      trendTitle: "Feedback Trend",
      timePeriod: "Time Period",
      reportCount: "Report Count",
      topDisputedTitle: "Top 3 Disputed Reports",
      colRank: "Rank",
      colReportName: "Report Name",
      disagrees: "Disagrees",
      feedbackListTitle2: "Feedback List",
      mTotalReports: "Total Reports",
      mFeedbackAgree: "Feedback : Agree",
      mFeedbackDisagree: "Feedback: Disagree",
      colTimestampReport: "Timestamp / Report Type & ID",
      colUserNameRole: "User Name & Role",
      colFeedbackValue: "Feedback Value",
      colComments: "Comments",
      na: "N/A",
      apply: "Apply",
      clear: "Clear",
    },
    // ---- Client Admin AI Reports (dashboard / manage / usage / history / guide) ----
    aiClient: {
      credits: "Credits",
      cancel: "Cancel",
      save: "Save",
      back: "Back",
      close: "Close",
      search: "Search",
      makeSelection: "Make a selection",
      errorTitle: "Error",
      successTitle: "Success",
      loadFailed: "Could not load data. Please try again.",
      saveFailed: "Could not save. Please try again.",
      saved: "Settings saved successfully.",
      // report type labels (5 client-facing types)
      rt_vegetation_vigor: "Vegetation Vigor",
      rt_farm_productivity: "Farm Productivity",
      rt_anomaly_detection: "Anomalies Detection",
      rt_yield_prediction: "Yield Prediction",
      rt_disease_detection: "Disease Detection",
      rt_land_suitability: "Land Suitability",
      // dashboard
      dashTitle: "AI Reports Dashboard",
      dashGuide: "Dashboard Guide",
      builders: "AI Report Builders",
      distributionTitle: "Report Type Distribution",
      colReportType: "Report Type",
      colReportsGenerated: "Reports Generated",
      recentTitle: "Recent AI Reports",
      noRecent: "No reports generated yet.",
      noDistribution: "No report activity yet.",
      na: "N/A",
      // report builder labels
      bVegetationVigor: "Vegetation Vigor Analysis",
      bFarmProductivity: "Farm Productivity Analysis",
      bAnomalies: "Anomalies Detection",
      bYield: "Yield Prediction",
      bDisease: "Disease Detection",
      bLand: "Land Suitability",
      // AI insights & analytics
      insightsTitle: "AI Insights and Analytics",
      iVegHealth: "Average Vegetation Health",
      iDisease: "Disease Detected this Month",
      iAnomalies: "Anomalies this Month",
      iYieldTrend: "Predicted Yield Trend",
      // credits summary card + popover
      creditsAvailableLabel: "Available",
      totalCredits: "Total Credits:",
      creditsUsedLabel: "Credits Used:",
      topUp: "Top Up Credits",
      topUpInfo: "Contact your administrator to top up credits.",
      creditsHistory: "Credits History",
      manageBtn: "Manage AI Reporting & Credits",
      // manage page
      manageTitle: "Manage AI Reporting & Credits",
      usageLogBtn: "Credits Usage Log",
      cardAvailable: "Credits Available",
      cardTotal: "Total Credits",
      cardUsed: "Credit Used",
      refreshesOn: "Refreshes On",
      assignedOn: "Assigned On",
      distBudgetTitle: "AI Report Distribution & Budgeting",
      distBudgetHelp:
        "Configure AI reporting access for your Unions, Factories, and Farmers. Allocate specific credit budgets to each level to manage your cooperative's resource consumption efficiently.",
      group_cooperative: "Cooperative",
      group_buying_station: "Buying Station",
      group_farmer: "Farmer",
      monthlyCredits: "Monthly Credits",
      aiReports: "AI Reports",
      enabled: "Enabled",
      disabled: "Disabled",
      overAllocation: "Group allocations exceed the cooperative credit budget.",
      // usage log page
      usageLogTitle: "Credits Usage Log",
      filterCooperative: "Cooperative",
      filterReport: "AI Report",
      colDateTime: "Date & Time",
      colEntity: "Entity",
      colAiReport: "AI Report",
      colCreditsUsed: "Credits Used",
      colBalance: "Balance",
      // history dialog
      historyTitle: "Credits History",
      historyDesc:
        "A overview of credit allocations versus consumption for this cooperative. Use this summary to track monthly usage trends and billing cycles.",
      coopLabel: "Cooperative",
      colMonth: "Month",
      colCreditsAssigned: "Credits Assigned",
      colClosingBalance: "Closing Balance",
      noHistory: "No credit history yet.",
      // dashboard guide
      guideTitle: "Dimitra AI Reports Dashboard Guide",
      guideStep: "Step",
      guideOf: "of",
      guideClose: "Close",
      guideSkip: "Skip",
      guideNext: "Next",
      guideBack: "Back",
      guideDone: "Close",
      g1Title: "Dashboard Overview",
      g1Intro:
        "Welcome to your AI insights hub. This guide will walk you through interpreting the map, managing your credits, and using the AI models.",
      g1Points: [
        "Understand Map Insights: Use the filters on the map to view specific provinces and regions. The heatmap provides an instant color-coded view of farm performance across the cooperative, with keys for High/Medium/Low indicators.",
        "Monitor Credits: Your current available credits are shown in the top right header. Make sure you have sufficient balance before generating large reports.",
      ],
      g2Title: "Understanding AI Reports",
      g2Intro:
        "Your dashboard provides access to specialized AI models. Each report analyzes different aspects of your agricultural data.",
      g2Points: [
        "Vegetation Vigor: Assess overall crop health and identify areas needing attention.",
        "Farm Productivity: Analyze historical productivity trends to optimize yield potential.",
        "Anomalies Detection: Spot irregular field patterns that may indicate stress or external threats.",
        "Yield Prediction: Forecast harvest outcomes based on current growth data.",
        "Disease Detection: Use plant imagery to instantly identify specific diseases.",
      ],
      g3Title: "How Credits Work",
      g3Intro:
        "Dimitra uses a credit-based system to manage AI resource consumption. Credits act as the currency for generating reports.",
      g3Points: [
        "Allocation: Your Cooperative is assigned a monthly balance by your Administrator.",
        "Consumption: Every time you trigger a report generation, credits are deducted from your 'Credits Available' pool.",
        "Visibility: You can track every deduction in your dedicated credit ledger.",
      ],
      g4Title: "Monitoring Usage & Credit History",
      g4Intro: "Stay in control of your budget by keeping a close eye on your credit history.",
      g4Points: [
        "Available Balance: Always visible in the top-right card. Pay attention to the 'Refreshes On' date to know when your next allocation arrives.",
        "Usage Log: Click [ Credits History ] to view a detailed breakdown of which report was generated, when, and by which entity (Co-op, Union, Factory, or Farmer).",
        "Management: If you find yourself running low on credits, use the [ Manage AI Reporting & Credits ] button to adjust your entity-level budgets or reach out to your administrator for an additional 'Quick Top-up.'",
      ],
    },
    usersByStatus: "Users By Status",
    usersByGender: "Users By Gender",
    gen: "Gender",
    gender: "Gender Chart",
    male: "Male",
    female: "Female",
    other: "Other",
    unspefied: "Unspecified",
    byCountry: "By Country",
    avgPriceFarmer: "Average Selling Price By All Farmers",
    avgPrice: "Average Selling Price Per Farmer",
    selectYear: "Select Year",
    total: "Total",
    farmerName: "Farmer Name",
    farmerId: "Farmer ID",
    farmerProdChart: "Farmer Production Chart",
    production: "Production",
    byProduction: "By Production",
    byName: "By Name",
    descending: "Descending",
    ascending: "Ascending",
    buyingStationProdChart: "Buying Station Production Chart",
    buyingStation: "Buying Station",
    buyingStationName: "Buying Station Name",
    availableWeight: "Available Weight",
    dryMilling: "Dry Milling",
    dryMillingName: "Dry Milling Name",
    dryMillingProdChart: "Dry Milling Production Chart",
    // Kenya-only labels (gated via isKenyaClient): "buying station" -> "factory", "milling" -> "mill"
    factory: "Factory",
    factoryName: "Factory Name",
    factoryProdChart: "Factory Production Chart",
    dryMill: "Dry Mill",
    dryMillName: "Dry Mill Name",
    dryMillProdChart: "Dry Mill Production Chart",
    view: "View",
    date: "Date",
    reports: "Reports",
    today: "Today",
    week: "Week",
    month: "Month",
    year: "Year",
    all: "All",
    selectCrop: "Select Crop",
    selectRegion: "Select Region",
    selectProvinceState: "Select Province/State",
    downloadPdfReport: "Download PDF Report",
    export: "Export",
    search: "Search",
    yield: "Yield",
    avgAreaPerUnit: "Avg Area in {unit}",
    yieldPerUnit: "Yield/{unit}",
    averageSellingPriceByAllFarmers: "Average Selling Price by All Farmers",
    averageSellingPricePerFarmer: "Average Selling Price per Farmer",
    pricePaid: "Price Paid",
    pests: {
      pestReport: "Pest Report",
      filterByCrops: "Filter By Crops",
      pestStatistics: "Pest Statistics",
      regions: "Regions",
      occurrences: "Occurrences",
      pestChart: "Pest Chart",
      totalArea: "Total Area",
      pestName: "Pest Name",
      region: "Region",
      crop: "Crops",
      listByLand: "List By Land",
    },
    regions: {
      regionalReport: "Regional Report",
      listByFarm: "List by Farm",
      listByFarmers: "List by Farmers",
      listByYield: "List by Yield",
      regionalStatistics: "Regional Statistics",
      countries: "Countries",
      states: "States/Provinces",
      city: "City/Town/Village",
      farmsIn: "Farms in",
      regionalChart: "Regional Chart",
      farms: "Farms",
      regionName: "Region Name",
      farmers: "Farmers",
      yield: "Yield/Acre",
    },
    dashboard: {
      topCharts: "Top Charts",
      regions: "Regions",
      noOfFarms: "No. of Farms/Region",
      provinces: "Provinces states",
      landArea: "LandArea",
      avgFarmerLand: "Avg. Farmer land",
      viewAll: "View All",
      crops: "Crops",
      plantedAreaCrop: "Planted Area/Crop",
      plantedArea: "Planted Area",
      avgYieldCrop: "Avg. Yield/Crop",
      averageYield: "Average Yield",
      yieldChart: "Yield Chart",
      selectFarm: "Select Farm",
      soilQuality: "Soil Quality",
      pests: "Pests",
      occurrences: "occurrences",
      equipments: "Equipments",
      goalAchievedChart: "Goals Achieved Chart",
      soilValues: "Soil Values",
      soil: "Soil",
      showReport: "Show reports on Dashboard",
      selectAll: "Select All",
    },
    weight: "Weight",
    quality: "Quality",
    price: "Price",

    yieldPrediction: "Yield Prediction",
    listOfReports: "List of Reports",
    noYieldPredictionReportsFound: "No Yield Prediction Reports Found",
    loadingYieldPredictions: "Loading yield predictions...",
    createNewReport: "Create New Report",

    howToUseReport: "How to Use Report?",
    viewGuide: "View Guide",
    cancel: "Cancel",
    generateReport: "Generate Report",
    selectFarmGeofence: "Select Farm Geofence",
    selectFarmGeofenceDescription: "Select a registered farm, draw your farm boundary on the map, or enter a location to begin analyzing the yield prediction of our farm area.",
    point: "Point",
    geofence: "Geofence",
    selectFarmZone: "Select Farm/Zone",
    select: "Select",
    latitude: "Latitude",
    longitude: "Longitude",
    uploadGeojsonFile: "Upload Geojson File",
    uploadGeojsonFileDescription: "Select a GeoJSON file with your geofence from your computer and upload it. Only one geofence will be uploaded at a time, even if your file has multiple geofences.",
    selectAFile: "Select A File",
    hideAdvanced: "Hide Advanced",
    showAdvancedVariation: "Show Advanced Variation",
    uploadHistoricalYieldDataDescription: "Please upload the historical yield data of your farm",
    showInstructions: "Show Instructions",
    downloadTemplate: "Download Template",
    chooseFile: "Choose File",
    noFileSelected: "No file selected",
    yieldPredictionGuide: "Yield Prediction Guide",
    forecastedYields: "Forecasted Yields",
    farmArea: "Farm Area",
    yieldForecasts: "Yield Forecasts",
    graph: "Graph",
    actualYields: "Actual Yields",
    predictedFutureYields: "Predicted Future Yields",
    averageYields: "Average Yields",
    yieldTrendsGraph: "Yield Trends Graph",
    step1: "Step 1",
    step2: "Step 2",
    satelliteMapView: "Satellite Map View",
    selectYourFarm: "Select your farm from the dropdown menu (if already registered).",
    selectCropType: "Select a crop type:",
    clickGenerateReport: "Click 'Generate Report' to view your yield prediction report.",
    howToGenerateReport: "How to Generate a Report?",
    howToInterpretReport: "How to Interpret the Report?",
    tip: "Tip",

    disclaimer: "Disclaimer",
    disclaimer1: "It is impossible to accurately predict weather for an entire season. For example, hail or flooding can occur at any time, which can significantly impact yield predictions.",
    disclaimer2: "Yields are highly dependent on farmer management practices. For instance, timely application of pesticides or proper irrigation can greatly affect the final yield.",
    disclaimer3: "There are other factors that can contribute to significant errors in AI yield predictions.",
    startYear: "Start Year",
    endYear: "End Year",
    back: "Back",
    deleteReport: "Delete Report",
    confirmDeleteReport: "Are you sure you want to delete this yield prediction report? This action cannot be undone and all associated data will be permanently removed.",
    deleteConfirmation: "Delete Confirmation",
    download: "Download",
    report: "Report",
    dateOfReport: "Date of Report",
    farm: "Farm",
    location: "Location",
    zone: "Zone",
    crop: "Crop",
    farmers: "Farmers",
    yieldPerAcre: "Yield/Acre",
    yieldPerHectare: "Yield/Hectare",
    yieldPerSquareKilometer: "Yield/Square Kilometer",
    yieldPerSquareMile: "Yield/Square Mile",
    yieldPerSquareMeter: "Yield/Square Meter",
    yieldPerSquareYard: "Yield/Square Yard",
    yieldPerSquareFoot: "Yield/Square Foot",
    predictionModel: "Prediction Model",
    accuracy: "Accuracy (R²)",
    confidence: "Confidence",
    producer: "Producer",
    reportDeletedSuccessfully: "Report deleted successfully",
    failedToDeleteReport: "Failed to delete report",
    enterHere: "Enter here",
    hectares: "hectares",
    step3: "Step 3",
    step4: "Step 4",
    whatIsYieldReportTitle: "What is a Yield Prediction Report?",
    yieldReportDescription: "Yield Prediction Report helps you estimate crop yields for your farm using historical data, satellite data and AI-based predictive models. The report gives you an estimate of how much crop you might harvest in the current and coming years. The report provides insights into actual yields, predicted future yields, and average yields, enabling you to optimize your farming operations and plan ahead.",
    creatingYourReportEasy: "Creating your report is easy:",
    selectYourFarmDescription: "The boundary will appear on the map. Or, draw your farm boundary (polygon or a point) manually on the map if it's not registered yet. You can also search by typing Latitude and Longitude to zoom into a location.",
    selectCropTypeDescription: "Choose the crop you want to analyze from the dropdown menu.",
    clickGenerateReportDescription: "to view your yield prediction report.",
    interpretReportIntro: "Once the report is generated, you'll see yield forecasts for the current and upcoming year. A graph displays yield trends for your farm with three lines:",
    blueLineActualYields: "Blue Line (Actual Yields):",
    blueLineDescription: "Represents the real harvest results from previous seasons on your farm. This helps you understand past performance trends over time.",
    redLinePredictedYields: "Red Line (Predicted Future Yields):",
    redLineDescription: "Displays AI-based forecasts for upcoming yields. It provides an estimation of what you can expect (how much you might harvest) based on current data and trends.",
    brownLineAverageYields: "Brown Line (Average Yields):",
    brownLineDescription: "Indicates the average yield across all available data for the farm. This line serves as a benchmark to help you compare historical and predicted yields against the overall trend.",
    highPredictedYieldsLabel: "High predicted yields",
    highPredictedYieldsDescription: "suggest that current practices are effective. Maintain your strategies such as replicate them in other areas of your farm.",
    lowPredictedYieldsLabel: "Low predicted yields",
    lowPredictedYieldsDescription: "may indicate areas for improvement, such as planting schedules, soil health, fertilizer use, irrigation, pest management, water stress or nutrient deficiencies etc. Investigate and address these issues early to avoid further yield losses.",
    tipDescription: "You can save, download, or delete your reports for future reference.",
    validationError: "Validation Error",
    pleaseSelectCrop: "Please select a crop",
    pleaseEnterLatLng: "Please enter latitude and longitude or select a point on the map",
    pleaseDrawGeofence: "Please draw a geofence on the map or upload a GeoJSON file",
    invalidGeojsonFile: "Invalid GeoJSON file",
    invalidGeojsonFileDescription: "Please ensure the file is a valid GeoJSON format.",
    errorReadingFile: "Error reading file",
    failedToReadGeojson: "Failed to read the GeoJSON file. Please try again.",
    yieldReportGeneratedSuccessfully: "Yield prediction report generated successfully",
    failedToGenerateReport: "Failed to generate report. Please try again.",
    farmAndFarmId: "Farm & Farm ID",
    producerName: "Producer Name",
    failedToLoadReport: "Failed to load yield prediction report",
    reportDataNotLoaded: "Report data is not loaded. Please wait and try again.",
    pdfGeneratedSuccessfully: "PDF generated successfully",
    failedToGeneratePdf: "Failed to generate PDF. Please try again.",
    editMap: "Edit Map",
    editMapDescription: "Map editing functionality will be implemented here",
    noForecastDataAvailable: "No forecast data available",
    noGraphImageAvailable: "No graph image available",

    // Shared AI report redesign
    landSuitability: "Land Suitability",
    aiReportGuide: "AI Report Guide",
    aiReportsDashboard: "AI Reports Dashboard",
    aiReports: "AI Reports",
    dashboardGuide: "Dashboard Guide",
    aiReportBuilders: "AI Report Builders",
    aiInsightsAndAnalytics: "AI Insights and Analytics",
    reportTypeDistribution: "Report Type Distribution",
    reportType: "Report Type",
    reportsGenerated: "Reports Generated",
    recentAiReports: "Recent AI Reports",
    vegetationVigorAnalysis: "Vegetation Vigor Analysis",
    farmProductivityAnalysis: "Farm Productivity Analysis",
    anomaliesDetection: "Anomalies Detection",
    diseaseDetection: "Disease Detection",
    averageVegetationHealth: "Average Vegetation Health",
    diseaseDetectedThisMonth: "Disease Detected this Month",
    anomaliesThisMonth: "Anomalies this Month",
    predictedYieldTrend: "Predicted Yield Trend",
    comingSoon: "Coming soon",
    reportBuilderComingSoon: "This AI report builder is coming soon.",
    loadingRecentReports: "Loading recent reports…",
    noRecentAiReports: "No recent AI reports found.",
    backToDashboard: "Back to dashboard",
    reportsBreadcrumb: "Reports",
    customizeTable: "Customize table",
    customization: "Customization",
    recordsPerPage: "Records per page",
    visibleColumns: "Visible columns",
    restoreDefault: "Restore default",
    apply: "Apply",
    reportId: "Report ID",
    viewReport: "View report",
    noLandSuitabilityReportsFound: "No Land Suitability reports found.",
    confirmDeleteLandSuitabilityReport: "Are you sure you want to delete this Land Suitability report?",
    landSuitabilityReportDeletedSuccessfully: "Land Suitability report deleted successfully.",
    unableToDeleteReport: "Unable to delete the report.",
    unableToDeleteReportRetry: "Unable to delete the report. Please try again.",
    of: "of",
    estimatedComputeCost: "Estimated Compute Cost",
    totalCreditsRequired: "Total Credits Required",
    creditsAvailable: "Credits Available",
    status: "Status",
    credits: "Credits",
    creditsSufficient: "Credits Sufficient for AI Report Generation",
    insufficientCredits: "Insufficient Credits",
    selectFarm: "Select Farm",
    showAdvanced: "Show advanced",
    sourceFarmZone: "Farm / Zone",
    sourcePolygon: "Polygon",
    sourceCircle: "Circle",
    sourceGeojson: "GeoJSON",
    radiusM: "Radius (m)",
    drawPolygon: "Draw Polygon",
    drawPolygonHelp: "Click on the map to add points.",
    drawCircle: "Draw Circle",
    drawCircleHelp: "Click on the map to set the center; set the radius below or drag the circle to resize.",
    drawingHintPoint: "Click the map to place a point. Drag the marker to adjust it.",
    drawingHintGeofence: "Click at least three locations to draw the geofence. Drag points to adjust it.",
    drawingHintPointShort: "Click the map to place or move the point",
    drawingHintGeofenceShort: "Click at least three locations to draw the farm boundary",
    undoLastGeofencePoint: "Undo last geofence point",
    undoLastPoint: "Undo last point",
    clearGeofence: "Clear geofence",
    previousImage: "Previous image",
    nextImage: "Next image",
    selectDate: "Select Date",
    reportDetails: "Report Details",
    greenAreas: "Green Areas",
    yellowAreas: "Yellow Areas",
    redAreas: "Red Areas",
    greenAreasDescription: "Current vegetation vigor outperforms historical average",
    yellowAreasDescription: "Current vegetation vigor performs according to historical average",
    redAreasDescription: "Areas with poor crop performance that require immediate attention",
    underperforming: "Underperforming",
    outperforming: "Outperforming",
    landSuitabilityDisclaimer: "This AI-generated report is intended to serve as a guide. For accurate diagnosis and tailored recommendations, consult a qualified agronomist or agricultural expert.",
    startDate: "Start Date",
    numberOfHistoricalReports: "Number of Historical Reports",
    compareReports: "Compare reports",
    satelliteImageryNote: "Satellite imagery for the exact report date may not be available. The closest available satellite layer is shown instead.",
    farmLocation: "Farm location",
    feedback: "Feedback",
    feedbackColon: "Feedback:",
    agreedWithPrediction: "Agreed with Prediction",
    predictionNotAccurate: "Prediction Not Accurate",
    attachments: "Attachments",
    noAttachmentsAdded: "No attachments added",
    doYouAgreeWithPrediction: "Do you agree with the prediction?",
    agree: "Agree",
    disagree: "Disagree",
    agreeWithPrediction: "Agree with prediction",
    disagreeWithPrediction: "Disagree with prediction",
    feedbackDisagreementPlaceholder: "Tell us what does not reflect the current reality of the field",
    addAttachments: "Add attachments",
    removeAttachment: "Remove attachment",
    submitFeedback: "Submit feedback",
    loadingFeedback: "Loading feedback",
    attachment: "Attachment",
    unableToLoadAvailableCrops: "Unable to load available crops.",
    unableToGenerateReport: "Unable to generate the report.",
    unableToLoadLandSuitabilityReport: "Unable to load the Land Suitability report.",
    unableToDownloadReport: "Unable to download the report.",
    pleaseSelectValidGeojson: "Please select a valid Polygon or MultiPolygon GeoJSON file.",
    historicalComparisonUnavailable: "Historical comparison is not available from the current report API.",
    unableToLoadFeedback: "Unable to load feedback.",
    unableToLoadReportFeedback: "Unable to load report feedback.",
    attachmentTypeSizeLimit: "Attachments must be images or videos no larger than 10 MB.",
    unableToSubmitFeedback: "Unable to submit feedback.",
    feedbackSubmittedSuccessfully: "Feedback submitted successfully.",
    unableToSubmitFeedbackRetry: "Unable to submit feedback. Please try again.",
    openReportToViewGuide: "Open a report to view the complete AI report guide.",
    downloadReport: "Download report",
    pleaseSelectPointOnMap: "Please select a point on the map",
    pleaseDrawPolygonMinPoints: "Please draw a polygon with at least 3 points",
  },
}